import React from 'react'
import Button from 'shared/Button'
import styled from 'styled-components'
import AboutUsInfo from './components/AboutUsInfo'
import AboutImage from 'assets/images/jpgs/AbtImg.jpg'
import { ABOUTUSCARDDATA, ABOUTUSDATA } from 'utilities/data'
import { Link } from 'react-router-dom'

const AboutUs = () => {
  return (
    <div>
      <div className='px-16 py-12 max-[450px]:px-8'>
        <AboutUsContainer>
          {ABOUTUSCARDDATA.map((content, index) => (
            <div key={index} className='w-[300px]'>
              <AboutUsInfo
                header={content.header}
                body={content.body}
                textColor="text-[#7A7A7A]"
              />
              <Link to={content.path}>
                <Button className="bg-[#F0CA18]">GET STARTED</Button>
              </Link>
            </div>
          ))}
        </AboutUsContainer>
      </div>
      <div className='px-16 max-[450px]:px-8 py-12 max-md:flex-wrap justify-center flex gap-12'>
        <div className='min-w-1/5'>
          <img src={AboutImage} alt="AboutImage" />
        </div>
        <div className='md:w-3/5'>
          <AboutUsInfo
            header={ABOUTUSDATA.header}
            body={ABOUTUSDATA.body}
            extraBody={ABOUTUSDATA.extraBody}
            textColor="text-[#7A7A7A]"
          />
          <Link to="/about">
            <Button className="bg-[#FFFFFF]">
              READ MORE
            </Button>
          </Link>
        </div>
      </div>
      <Divider className='w-full h-[5px]'></Divider>
    </div>
  )
}

export default AboutUs

const AboutUsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;

  @media screen and (max-width: 760px) {
    justify-content: center;
  }
`;
const Divider = styled.div`
  background: linear-gradient(270deg, #F57200 -94.44%, #F0CA18 108.89%);
`;